export default {
    computed: {
        isSmallDevice(){
            return ['xs', 'sm'].includes(this.$vuetify.breakpoint.name);
        }
    }
};